import React from "react"
import SEO from "../components/SEO"

const Disclaimer: React.FC = () => {
  return (
    <>
      <SEO
        title="Disclaimer"
        description="Read the disclaimer for Thecodebazaar.com regarding digital products, services, and limitations of liability."
      />

      {/* Hero Section */}
      <div className="bg-gradient-to-br from-sky-50 to-blue-50 py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold text-gray-900 text-center">
            Disclaimer
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl p-8 md:p-12 border border-gray-200 shadow-sm">
          <p className="text-gray-600 mb-8">
            Last updated: January 2025
          </p>

          <div className="prose max-w-none space-y-8">
            {/* 1 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                1. General Information
              </h2>
              <p className="text-gray-700">
                The information provided on <strong>Thecodebazaar.com</strong> is
                for general informational and educational purposes only. All
                content, products, and services are provided in good faith;
                however, we make no representation or warranty of any kind,
                express or implied, regarding the accuracy, adequacy, validity,
                reliability, availability, or completeness of any information.
              </p>
            </section>

            {/* 2 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                2. Digital Products Disclaimer
              </h2>
              <p className="text-gray-700">
                Thecodebazaar.com sells digital products such as website themes,
                templates, UI components, source code, courses, and other
                downloadable resources. Due to the nature of digital products:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mt-3">
                <li>All sales are generally final unless otherwise stated</li>
                <li>We do not guarantee specific results from using our products</li>
                <li>Compatibility may vary based on third-party tools, hosting, or platforms</li>
                <li>Users are responsible for proper implementation and usage</li>
              </ul>
            </section>

            {/* 3 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                3. Professional Disclaimer
              </h2>
              <p className="text-gray-700">
                The content on this website does not constitute professional,
                legal, financial, or business advice. Any action you take based
                on the information found on this website is strictly at your own
                risk. We recommend consulting a qualified professional before
                making any decisions.
              </p>
            </section>

            {/* 4 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                4. External Links Disclaimer
              </h2>
              <p className="text-gray-700">
                Thecodebazaar.com may contain links to external websites or
                third-party resources. We do not monitor or guarantee the
                accuracy, relevance, timeliness, or completeness of any
                third-party information. We are not responsible for any loss or
                damage caused by your use of third-party websites.
              </p>
            </section>

            {/* 5 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                5. Earnings & Results Disclaimer
              </h2>
              <p className="text-gray-700">
                Any examples of income, growth, or results mentioned on this
                website are not guarantees of future performance. Individual
                success depends on multiple factors such as skills, experience,
                effort, and market conditions.
              </p>
            </section>

            {/* 6 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                6. Limitation of Liability
              </h2>
              <p className="text-gray-700">
                Under no circumstances shall Thecodebazaar.com, its owner, team,
                or affiliates be liable for any direct, indirect, incidental,
                consequential, or special damages arising from your use of the
                website, products, or services.
              </p>
            </section>

            {/* 7 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                7. Use at Your Own Risk
              </h2>
              <p className="text-gray-700">
                All products, services, and content are provided “as is” and “as
                available” without warranties of any kind. You agree that your
                use of Thecodebazaar.com is solely at your own risk.
              </p>
            </section>

            {/* 8 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                8. Jurisdiction
              </h2>
              <p className="text-gray-700">
                This disclaimer shall be governed and interpreted in accordance
                with the laws of India. Any disputes shall be subject to the
                jurisdiction of courts located in Madhya Pradesh, India.
              </p>
            </section>

            {/* 9 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                9. Contact Us
              </h2>
              <p className="text-gray-700">
                If you have any questions regarding this Disclaimer, you may
                contact us through our official communication channels available
                on Thecodebazaar.com.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  )
}

export default Disclaimer